// CardPage.jsx
import React, { useRef, useEffect } from "react";
import PDFWrapper from "./PDFWrapper";
import DLCardLayout from "./DLCardLayout";

export default function DlCardPage({ dlData, apiTriggerDownload }) {
  const pdfRef = useRef();

  // Call this from API function when needed:
  useEffect(() => {
    // Register callback once after mount
    apiTriggerDownload(() => {
      pdfRef.current?.generatePDF();
    });
  }, []);

  return (
    <>
      <PDFWrapper ref={pdfRef} fileName={`${dlData?.dlNumber}.pdf`}>
        <DLCardLayout dlData={dlData} />
      </PDFWrapper>
    </>
  );
}
